var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 10.3125L14.1275 7.3125L8.9375 4.3125V10.3125ZM20.4975 2.4825C20.6275 2.9525 20.7175 3.5825 20.7775 4.3825C20.8475 5.1825 20.8775 5.8725 20.8775 6.4725L20.9375 7.3125C20.9375 9.5025 20.7775 11.1125 20.4975 12.1425C20.2475 13.0425 19.6675 13.6225 18.7675 13.8725C18.2975 14.0025 17.4375 14.0925 16.1175 14.1525C14.8175 14.2225 13.6275 14.2525 12.5275 14.2525L10.9375 14.3125C6.7475 14.3125 4.1375 14.1525 3.1075 13.8725C2.2075 13.6225 1.6275 13.0425 1.3775 12.1425C1.2475 11.6725 1.1575 11.0425 1.0975 10.2425C1.0275 9.4425 0.9975 8.7525 0.9975 8.1525L0.9375 7.3125C0.9375 5.1225 1.0975 3.5125 1.3775 2.4825C1.6275 1.5825 2.2075 1.0025 3.1075 0.7525C3.5775 0.6225 4.4375 0.5325 5.7575 0.4725C7.0575 0.4025 8.2475 0.3725 9.3475 0.3725L10.9375 0.3125C15.1275 0.3125 17.7375 0.4725 18.7675 0.7525C19.6675 1.0025 20.2475 1.5825 20.4975 2.4825Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.c13fd38fc6e8882f331b0f2198890341.svg";
export { ForwardRef as ReactComponent };